import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { useEditorContext } from 'routes/Editor/EditorContext';
import { Tabs, TabList, TabPanels, TabPanel, Tab } from '@reach/tabs';
import ExportModalEmailProvider from './ExportModalEmailProvider/ExportModalEmailProvider';
import ExportModalApplication from './ExportModalApplication/ExportModalApplication';
import ExportModalFile from './ExportModalFile/ExportModalFile';
import './ExportModal.sass';

export const ExportModal = ({ onClose }) => {
  const {
    template: { name: templateName, id: templateId },
  } = useEditorContext();

  const [isLoading, setIsLoading] = useState(false);
  const [selectedItem, setSelectedItem] = useState();

  return (
    <div className="export-modal">
      <Tabs>
        <TabList>
          <Tab as="div">
            <FormattedMessage id="export-modal.tab-title.email-provider" />
          </Tab>
          <Tab as="div">
            <FormattedMessage id="export-modal.tab-title.application" />
          </Tab>
          <Tab as="div">
            <FormattedMessage id="export-modal.tab-title.file" />
          </Tab>
        </TabList>
        <TabPanels>
          <TabPanel>
            <ExportModalEmailProvider
              templateId={templateId}
              isLoading={isLoading}
              setIsLoading={setIsLoading}
              selectedItem={selectedItem}
              setSelectedItem={setSelectedItem}
            />
          </TabPanel>
          <TabPanel>
            <ExportModalApplication
              templateId={templateId}
              isLoading={isLoading}
              setIsLoading={setIsLoading}
              selectedItem={selectedItem}
              setSelectedItem={setSelectedItem}
            />
          </TabPanel>
          <TabPanel>
            <ExportModalFile
              onClose={onClose}
              templateName={templateName}
              templateId={templateId}
              isLoading={isLoading}
              setIsLoading={setIsLoading}
              selectedItem={selectedItem}
              setSelectedItem={setSelectedItem}
            />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </div>
  );
};

ExportModal.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export default ExportModal;
